// extracted by mini-css-extract-plugin
export default {"orthophotoPreview":"OrthophotoPreview_orthophotoPreview__WFcij","orthophoto-wrapper":"OrthophotoPreview_orthophoto-wrapper__Dzf0C","ortho-img":"OrthophotoPreview_ortho-img__Z9Rsj"};